import React, { useRef } from 'react';
import { Autocomplete } from '@react-google-maps/api';
import { useGoogleMaps } from '../maps/GoogleMapsLoader';
import './AddressInput.css';

const AddressInput = ({
    value,
    onChange,
    onPlaceSelect,
    onFocus,
    placeholder = "Dirección completa",
    maxLength = 255,
    disabled = false
}) => {
    const autocompleteRef = useRef(null);
    const { isLoaded } = useGoogleMaps();

    const handlePlaceSelect = () => {
        if (autocompleteRef.current) {
            const place = autocompleteRef.current.getPlace();

            if (place.geometry) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                const address = place.formatted_address || place.name || '';

                // Llamar al callback con los datos completos
                if (onPlaceSelect) {
                    onPlaceSelect({
                        address,
                        lat,
                        lng
                    });
                } else if (onChange) {
                    // Fallback si solo se provee onChange
                    onChange({ target: { value: address } });
                }
            }
        }
    };

    const handleInputChange = (e) => {
        if (onChange) {
            onChange(e);
        }
    };

    // Si Google Maps no está cargado, mostrar input normal
    if (!isLoaded) {
        return (
            <div className="address-input-wrapper">
                <input
                    type="text"
                    value={value}
                    onChange={handleInputChange}
                    onFocus={onFocus}
                    placeholder={placeholder}
                    className="address-autocomplete-input"
                    maxLength={maxLength}
                    disabled={disabled}
                />
            </div>
        );
    }

    return (
        <div className="address-input-wrapper">
            <Autocomplete
                onLoad={(autocomplete) => { autocompleteRef.current = autocomplete; }}
                onPlaceChanged={handlePlaceSelect}
                options={{
                    componentRestrictions: { country: 'mx' },
                    fields: ['geometry', 'formatted_address', 'name']
                }}
            >
                <input
                    type="text"
                    value={value}
                    onChange={handleInputChange}
                    onFocus={onFocus}
                    placeholder={placeholder}
                    className="address-autocomplete-input"
                    maxLength={maxLength}
                    disabled={disabled}
                />
            </Autocomplete>
        </div>
    );
};

export default AddressInput;
